<template>
    <div v-cloak>
        <v-file-input @change="OnFileChange"
                      accept="image/jpg, image/jpeg"
                      prepend-icon="fas fa-camera"
                      placeholder="Click to browse and upload a photo from your device"
                      show-size
                      counter
                      v-model="uploadedFile"></v-file-input>

        <confirm-dialog instance="confirm-photo-upload"
                        title="Confirm Photo"
                        question="Are you sure you want to submit this photo?"
                        no-label="No, not at this time"
                        yes-label="Yes, submit this photo"
                        button-color="success"></confirm-dialog>
    </div>
</template>

<script>
    import { eventBus } from '@/main'
    import confirmDialog from '@/views/components/dialogs/ConfirmDialog'

    export default {
        components: {
            'confirm-dialog': confirmDialog,
        },
        data() {
            return {
                uploadedFile: null,
                filename: null,
                mimeType: null,
                contents: null,
            }
        },
        methods: {
            OnFileChange(file) {
                this.filename = null;
                this.mimeType = null;
                this.contents = null;

                if (!!file) {
                    this.filename = file.name;
                    this.mimeType = file.type;
                    this.GetFileContents(file);
                }
            },
            GetFileContents(file) {
                const reader = new FileReader();

                reader.onload = e => {
                    this.contents = e.target.result;
                    this.Confirm();
                };

                reader.readAsDataURL(file);
            },
            Confirm() {
                eventBus.$off('confirm-photo-upload:ok').$on('confirm-photo-upload:ok', () => eventBus.$emit('photo:save', this.filename, this.mimeType, this.contents, this.uploadedFile.size));
                eventBus.$emit('confirm-photo-upload:show');
            },
        },
    }
</script>
